import { get } from "../../utils/BaseService";


export async function getEditionByTenantId(dispatch: any, id: number|null) {
   return await get(dispatch, `/tenantEdition/getEditionByTenantId/${id}`, null); // Pass empty object as input
}